// NotificationBanner.js
import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const NotificationBanner = () => {
  const [notificationMessage, setNotificationMessage] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotificationMessage = async () => {
      try {
        const response = await fetch('/api/admin-configuration?_format=json');
        const data = await response.json();
        setNotificationMessage(data.header_notifcation || ''); // Default to empty string if no message
        setLoading(false);
      } catch (error) {
        console.error('Error fetching notification message:', error);
        setNotificationMessage(''); // Fallback to empty message on error
        setLoading(false);
      }
    };

    fetchNotificationMessage();
  }, []);

  if (loading) {
    return null; // Optionally, you can show a loading spinner or placeholder
  }

  return (
    notificationMessage && (
      <div className="bg-primary text-white text-center py-2">
        <small>{notificationMessage}</small>
      </div>
    )
  );
};

export default NotificationBanner;